import { Button, Form, InputGroup } from "react-bootstrap";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import CustomModal from "../../Common/Modal/CustomModal";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { fetchCountryFormList } from "../../../actions/country";
import { fetchImportProducts } from "../../../actions/product";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ImportModal = ({ show, hideModal }) => {
  const [selectedOption, setSelectedOption] = useState("product");
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // Dropzone funkcionalnost
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => setFile(acceptedFiles[0]),
    accept: ".xlsx,.xls",
    multiple: false,
  });

  const [countryValue, setCountryValue] = useState("");
  const { countryFormList } = useSelector((state) => state.countryReducer);

  // Promena selektovanog radio dugmeta
  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  // Promena fajla putem inputa
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = () => {
    if (!file) {
      toast.error("Morate izabrati fajl", { theme: "colored" });
      return;
    }
    if (!selectedOption) {
      toast.error("Morate izabrati tip za importovanje", { theme: "colored" });
      return;
    }
    if (!countryValue) {
      toast.error("Morate izabrati drzavu", { theme: "colored" });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", selectedOption);
    formData.append("countryId", countryValue);

    dispatch(fetchImportProducts(formData, selectedOption));
    hideModal(); // Zatvori modal nakon upload-a
  };

  //pozvati podatke za drzave kako bi izlistali u selektu
  useEffect(() => {
    dispatch(fetchCountryFormList());
  }, [dispatch]);

  const handleChangeCountry = (event) => {
    setCountryValue(event.target.value);
  };

  return (
    <CustomModal
      show={show}
      hideModal={hideModal}
      modalTitle={t("button.import")}
      size="md"
      actionSubmitModal={handleUpload}
    >
      <div>
        <FormControl fullWidth size="small" required className="mb-3">
          <InputLabel id="demo-simple-select-label">
            {t("storeForm.country")}
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={countryValue}
            label={t("storeForm.country")}
            onChange={handleChangeCountry}
            size="small"
          >
            {countryFormList?.map((item, key) => (
              <MenuItem value={item.id} key={key}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl>
          <FormLabel id="demo-controlled-radio-buttons-group">
            {t("button.importType")}
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            onChange={handleRadioChange}
            row
            value={selectedOption}
          >
            <FormControlLabel
              value="product"
              control={<Radio />}
              label={t("button.product")}
            />
            <FormControlLabel
              value="category"
              control={<Radio />}
              label={t("button.category")}
            />
          </RadioGroup>
        </FormControl>

        <div className="holder-info-import">
          <div className="holder-info-import-detail">
            {selectedOption == "product" ? (
              <div className="holder-info-import-detail-item">
                <img
                  src="/images/import-proizvoda.png"
                  alt="LG Master Klub"
                  className="img-fluid"
                />
                <div className="holder-info-import-detail-item-text">
                  <a href="/images/import-proizvoda.xlsx" target="_blank">
                    {t("import.info")}
                  </a>
                </div>
              </div>
            ) : (
              <div className="holder-info-import-detail-item">
                <img
                  src="/images/import-kat.png"
                  alt="LG Master Klub"
                  className="img-fluid"
                />
                <div className="holder-info-import-detail-item-text">
                  <a href="/images/import-kategorija.xlsx" target="_blank">
                    {t("import.info")}
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          {...getRootProps()}
          style={{
            border: "2px dashed #a50034",
            padding: "35px 20px 20px 20px",
            textAlign: "center",
            marginBottom: "20px",
            marginTop: "20px",
            cursor: "pointer",
          }}
        >
          <UploadFileOutlinedIcon
            style={{ fontSize: "35px", color: "#c2c2c2", marginBottom: "10px" }}
          />
          <input {...getInputProps()} onChange={handleFileChange} />
          {file ? (
            <p>
              {t("button.chooseFile")}: {file.name}
            </p>
          ) : (
            <p>{t("button.moveFile")}</p>
          )}
        </div>

        <TextField
          type="file"
          onChange={handleFileChange}
          accept=".xlsx,.xls"
          fullWidth
          hidden
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton component="label">
                  <UploadFileOutlinedIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
      </div>
    </CustomModal>
  );
};

export default ImportModal;
